module.exports = __webpack_public_path__ + "img/car_00028.546e176f.jpg";